import { InternalLink } from '@/routing/types'
import { assets } from '@/ui/assets'
import { InternalLinkButton } from '@/ui/atoms/link-button/LinkButton'
import { Panel } from '@/ui/atoms/panel/Panel'

export interface BorrowUsdcViaUsdsBannerProps {
  link: InternalLink
}

export function BorrowUsdcViaUsdsBanner({ link }: BorrowUsdcViaUsdsBannerProps) {
  return (
    <Panel spacing="m" className="flex items-center gap-3 bg-primary sm:gap-5">
      <img
        src={assets.marketDetails.usdcUsdsIntersectIcon}
        alt="savings-usdc-upgrade-banner-icon"
        className="sm:-m-8 -m-4 w-[120px]"
      />
      <div className="flex w-full flex-col justify-between gap-2 md:flex-row md:items-center md:gap-8">
        <div className="flex flex-col gap-1">
          <div className="typography-label-2 sm:typography-label-1 text-primary">Borrow USDC via USDS</div>
          <div className="typography-body-4 hidden text-secondary md:block">
            Borrow USDC via the USDS market to access deeper liquidity.
          </div>
        </div>
        <InternalLinkButton variant="secondary" size="xs" className="sm:hidden" {...link}>
          Borrow
        </InternalLinkButton>
        <InternalLinkButton variant="secondary" size="m" className="hidden sm:inline-flex" {...link}>
          Borrow
        </InternalLinkButton>
      </div>
    </Panel>
  )
}
